<template>
  <!-- Candidate Details -->
  <div
    class="offcanvas offcanvas-end offcanvas-large"
    tabindex="-1"
    id="candidate_details"
  >
    <div class="offcanvas-header border-bottom">
      <h4 class="d-flex align-items-center">
        Candidate Details
        <span class="badge bg-primary-transparent fw-medium ms-2">Cand-001</span>
      </h4>
      <button
        type="button"
        class="btn-close custom-btn-close"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      >
        <i class="ti ti-x"></i>
      </button>
    </div>
    <div class="offcanvas-body">
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-center flex-wrap flex-md-nowrap row-gap-3">
            <span class="avatar avatar-xxxl candidate-img flex-shrink-0 me-3">
              <img src="@/assets/img/users/user-03.jpg" alt="Img" />
            </span>
            <div class="flex-fill border rounded p-3 pb-0">
              <div class="row align-items-center">
                <div class="col-md-4">
                  <div class="mb-3">
                    <p class="mb-1">Candiate Name</p>
                    <h6 class="fw-normal">Harold Gaynor</h6>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <p class="mb-1">Applied Role</p>
                    <h6 class="fw-normal">Accountant</h6>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <p class="mb-1">Applied Date</p>
                    <h6 class="fw-normal">12 Sep 2024</h6>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <p class="mb-1">Email</p>
                    <h6 class="fw-normal">harold@example.com</h6>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <p class="mb-1">Recruiter</p>
                    <h6 class="fw-normal d-flex align-items-center">
                      <span class="avatar avatar-xs avatar-rounded me-1">
                        <img src="@/assets/img/users/user-01.jpg" alt="Img" />
                      </span>
                      Anthony Lewis
                    </h6>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <p class="mb-1">Recruiter</p>
                    <span class="badge badge-purple d-inline-flex align-items-center"
                      ><i class="ti ti-point-filled me-1"></i>New</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="contact-grids-tab p-0 mb-3">
        <ul class="nav nav-underline" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button
              class="nav-link active pt-0"
              id="info-tab"
              data-bs-toggle="tab"
              data-bs-target="#basic-info"
              type="button"
              role="tab"
              aria-selected="true"
            >
              Profile
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link pt-0"
              id="address-tab"
              data-bs-toggle="tab"
              data-bs-target="#address"
              type="button"
              role="tab"
              aria-selected="false"
            >
              Hiring Pipeline
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link pt-0"
              id="address-tab2"
              data-bs-toggle="tab"
              data-bs-target="#address2"
              type="button"
              role="tab"
              aria-selected="false"
            >
              Notes
            </button>
          </li>
        </ul>
      </div>
      <div class="tab-content" id="myTabContent">
        <div
          class="tab-pane fade show active"
          id="basic-info"
          role="tabpanel"
          aria-labelledby="info-tab"
          tabindex="0"
        >
          <div class="card">
            <div class="card-header">
              <h5>Personal Information</h5>
            </div>
            <div class="card-body pb-0">
              <div class="row align-items-center">
                <div class="col-md-3">
                  <div class="mb-3">
                    <p class="mb-1">Candiate Name</p>
                    <h6 class="fw-normal">Harold Gaynor</h6>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <p class="mb-1">Phone</p>
                    <h6 class="fw-normal">(146) 8964 278</h6>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <p class="mb-1">Gender</p>
                    <h6 class="fw-normal">Male</h6>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <p class="mb-1">Date of Birth</p>
                    <h6 class="fw-normal">23/10/2000</h6>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <p class="mb-1">Email</p>
                    <h6 class="fw-normal">harold@example.com</h6>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <p class="mb-1">Nationality</p>
                    <h6 class="fw-normal">Indian</h6>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <p class="mb-1">Religion</p>
                    <h6 class="fw-normal">Christianity</h6>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <p class="mb-1">Marital status</p>
                    <h6 class="fw-normal">No</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header">
              <h5>Address Information</h5>
            </div>
            <div class="card-body pb-0">
              <div class="row align-items-center">
                <div class="col-md-3">
                  <div class="mb-3">
                    <p class="mb-1">Address</p>
                    <h6 class="fw-normal">1861 Bayonne Ave</h6>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <p class="mb-1">City</p>
                    <h6 class="fw-normal">New York</h6>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <p class="mb-1">State</p>
                    <h6 class="fw-normal">New York</h6>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <p class="mb-1">Country</p>
                    <h6 class="fw-normal">United States Of America</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header">
              <h5>Resume</h5>
            </div>
            <div class="card-body pb-0">
              <div class="row align-items-center">
                <div class="col-md-6">
                  <div class="d-flex align-items-center mb-3">
                    <span class="avatar avatar-lg bg-light-500 border text-dark me-2"
                      ><i class="ti ti-file-description fs-24"></i
                    ></span>
                    <div>
                      <h6 class="fw-medium">Resume.doc</h6>
                      <span>120 KB</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3 text-md-end">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-dark d-inline-flex align-items-center"
                      ><i class="ti ti-download me-1"></i>Download</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="address"
          role="tabpanel"
          aria-labelledby="address-tab"
          tabindex="0"
        >
          <div class="card">
            <div class="card-body">
              <h5 class="fw-medium mb-2">Candidate Pipeline Stage</h5>
              <div class="pipeline-list candidates border-0 mb-0">
                <ul class="mb-0">
                  <li><a href="javascript:void(0);" class="bg-purple">New</a></li>
                  <li><a href="javascript:void(0);" class="bg-gray-100">Scheduled</a></li>
                  <li>
                    <a href="javascript:void(0);" class="bg-grat-100">Interviewed</a>
                  </li>
                  <li><a href="javascript:void(0);" class="bg-gray-100">Offered</a></li>
                  <li>
                    <a href="javascript:void(0);" class="bg-gray-100">Hired / Rejected</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header">
              <h5>Details</h5>
            </div>
            <div class="card-body pb-0">
              <div class="row align-items-center">
                <div class="col-md-3">
                  <div class="mb-3">
                    <p class="mb-1">Current Status</p>
                    <span class="badge badge-soft-purple d-inline-flex align-items-center"
                      ><i class="ti ti-point-filled me-1"></i>New</span
                    >
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <p class="mb-1">Applied Role</p>
                    <h6 class="fw-normal">Accountant</h6>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <p class="mb-1">Applied Date</p>
                    <h6 class="fw-normal">12 Sep 2024</h6>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <p class="mb-1">Recruiter</p>
                    <div class="d-flex align-items-center">
                      <a
                        href="javascript:void(0);"
                        class="avatar avatar-sm avatar-rounded me-2"
                      >
                        <img src="@/assets/img/users/user-01.jpg" alt="Img" />
                      </a>
                      <h6><a href="javascript:void(0);">Anthony Lewis</a></h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="d-flex align-items-center justify-content-end">
                <a href="javascript:void(0);" class="btn btn-dark me-3">Reject</a>
                <a href="javascript:void(0);" class="btn btn-primary"
                  >Move to Next Stage</a
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="address2"
          role="tabpanel"
          aria-labelledby="address-tab2"
          tabindex="0"
        >
          <div class="card">
            <div class="card-header">
              <h5>Notes</h5>
            </div>
            <div class="card-body">
              <p>
                Harold Gaynor is a detail-oriented and highly motivated accountant with 4
                years of experience in financial reporting, auditing, and tax preparation.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Candidate Details -->

  <!-- Delete Modal -->
  <div class="modal fade" id="delete_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
            <i class="ti ti-trash-x fs-36"></i>
          </span>
          <h4 class="mb-1">Confirm Delete</h4>
          <p class="mb-3">
            You want to delete all the marked items, this cant be undone once you delete.
          </p>
          <div class="d-flex justify-content-center">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-3"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <router-link to="/recuritment/candidates-kanban" class="btn btn-danger"
              >Yes, Delete</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Modal -->
</template>
